import { useEffect } from "react";

const SITE_NAME = "Nikomedya Turizm";
const DEFAULT_DESC =
  "Nikomedya Turizm - 1983'ten beri Kocaeli'de personel ve öğrenci taşımacılığı, VIP taşımacılık ve araç kiralama hizmetleri.";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

// Her sayfa için özel başlık, açıklama, canonical ve Open Graph etiketleri
const useSEO = ({ title, description }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Personel ve Öğrenci Taşımacılığı`;
    const desc = description || DEFAULT_DESC;
    const url = `${window.location.origin}${window.location.pathname}`;

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", `${window.location.origin}/images/hero-1.webp`);
    setMeta("property", "og:locale", "tr_TR");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description]);
};

export default useSEO;
